module.exports = __webpack_public_path__ + "static/media/running.3e29e1ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/running.svg
// module id = 297
// module chunks = 0